const footerModule = document.querySelector<HTMLElement>('.footer-module');

if (footerModule) {
    const bodyHeight = document.body.scrollHeight;
    const viewportHeight = window.innerHeight;

    // If content is smaller than viewport, hide footer and do nothing else
    if (bodyHeight <= viewportHeight) {
        footerModule.classList.remove('nav-down');
        footerModule.classList.add('nav-up');
    } else {
        let lastScrollTop = 0;
        const delta = 5;
        const navbarHeight = footerModule.offsetHeight;
        let ticking = false;

        const onScroll = () => {
            if (ticking) return;
            ticking = true;

            requestAnimationFrame(() => {
                const scrollTop = window.scrollY;
                if (Math.abs(scrollTop - lastScrollTop) > delta) {
                    if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
                        footerModule.classList.replace('nav-down', 'nav-up');
                    } else if (scrollTop < lastScrollTop && scrollTop + window.innerHeight < document.documentElement.scrollHeight) {
                        footerModule.classList.replace('nav-up', 'nav-down');
                    }
                    lastScrollTop = scrollTop;
                }
                ticking = false;
            });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
    }
}